import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './http';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        // После возврата на вкладку обновляем только устаревшие данные.
        refetchOnWindowFocus: true,
        // Не крутим refetchInterval, пока вкладка скрыта.
        refetchIntervalInBackground: false,
        retry: (failureCount, error) => {
          // Ошибки клиента (401/403/404/422) повторять бессмысленно.
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 1;
        },
      },
    },
  });
}
